import React from 'react';
import { MapPin } from 'lucide-react';
import { AREAS } from '../data/site';
import { ServiceAreaMap } from './ServiceAreaMap';
import { TESTIDS } from '../constants/testIds';

export const Areas = () => {
  // Duplicate for marquee
  const loop = [...AREAS, ...AREAS];

  return (
    <section
      id="areas"
      data-testid={TESTIDS.areasSection}
      className="py-20 sm:py-28 bg-[#0A0A0A] border-y border-[#E8B842]/15 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <span className="font-display uppercase tracking-[0.4em] text-xs text-[#E8B842]">
              / Service area
            </span>
            <h2 className="font-display uppercase font-extrabold text-white text-4xl sm:text-5xl leading-[0.95] mt-4">
              Local to <span className="text-[#E8B842]">Leamington Spa</span>
            </h2>
            <p className="text-[#A3A3A3] text-base sm:text-lg leading-relaxed mt-5">
              Based in Royal Leamington Spa, we cover the town and all of the surrounding
              villages across Warwickshire. If you can&apos;t see your village listed, give us a
              ring — chances are we still come out to you.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-[#E8B842]">
              <MapPin className="w-5 h-5" />
              <span className="font-display uppercase tracking-widest text-sm">
                Leamington Spa · Warwickshire
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {AREAS.map((a) => (
                <div
                  key={a}
                  className="border border-[#E8B842]/15 hover:border-[#E8B842] bg-[#121212] px-4 py-3 transition-colors group"
                >
                  <div className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-[#E8B842] group-hover:scale-150 transition-transform" />
                    <span className="font-display uppercase tracking-wider text-sm text-white">
                      {a}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Service area map */}
        <div className="mt-12">
          <ServiceAreaMap />
        </div>
      </div>

      {/* Marquee strip */}
      <div className="mt-16 border-t border-[#E8B842]/20 bg-[#E8B842] text-black py-3 overflow-hidden">
        <div className="marquee-track">
          {loop.map((a, i) => (
            <span
              key={`${a}-${i}`}
              className="font-display uppercase tracking-[0.3em] text-sm font-bold whitespace-nowrap px-8"
            >
              ★ {a}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Areas;
